import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import React from 'react';
import { useParams } from 'react-router';
import { Headers, TaskSection } from 'shared/components/ui/task-section';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useActiveTaskId } from 'shared/contexts/task-detail';
import { lifeAreaOtherID } from 'shared/types/orderable-section';

import { useTagLifeAreaTaskSections } from '../../hooks/use-tag-life-area-task-sections';
import * as Styled from './life-area-grouping-tasks-list.style';

export const LifeAreaGroupingTasksList: React.FC = () => {
  const { id } = useParams();
  const { sections } = useTagLifeAreaTaskSections(id);

  const openPremiumDialog = useOpenPremiumDialog();

  const selectedTask = useActiveTaskId();

  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();

  return (
    <Styled.Container>
      {sections.map((section) => (
        <Styled.Section key={section.id}>
          <TaskSection
            goals={goals}
            lifeAreas={lifeAreas}
            onPremium={openPremiumDialog}
            tasks={section.items}
            lifeAreaId={section.id !== lifeAreaOtherID ? section.id : undefined}
            selectedTask={selectedTask}
            tagIds={id ? [id] : undefined}
            headerToDisplay={Headers.LifeArea}
            hideLifeArea
            canCreateTask
            canCollapse
            headerHasImage
          />
        </Styled.Section>
      ))}
    </Styled.Container>
  );
};
